import styled from 'styled-components'

const LogoBox = styled.div`
  display: flex;

  img {
    height: 2.5rem;
    margin-right: 1rem;
  }
`

export default LogoBox
